<template>
  <div class="container">
    <div class="header">
      <div class="nav_row">
        <div v-if="sourceIsH5" class="arrow" @click="goBack">
          <van-icon name="arrow-left" />
          <p class="back-title">{{ $t('返回') }}</p>
        </div>
      </div>
      <div class="userView">
        <div>
          <img class="avatar" src="@/assets/images/default_avatar.png" alt="" />
        </div>
        <div>
          <p class="name">{{ user.name }}</p>
          <p class="company">{{ user.companyName }}</p>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="information_bar">
        <div class="information_title">{{ $t('电话') }}</div>
        <div class="mobile_view" @click="callPhone">
          <div>{{ user.mobile }}</div>
        </div>
      </div>
      <div class="information_bar">
        <div class="information_title">{{ $t('邮箱') }}</div>
        <div>
          {{ user.mail }}
        </div>
      </div>
      <div class="information_bar">
        <div class="information_title">{{ $t('部门') }}</div>
        <div>{{ user.department }}</div>
      </div>
      <div v-if="haveTwodepartment" class="information_bar">
        <div class="information_title">{{ $t('部门2') }}</div>
        <div>{{ user.department2 }}</div>
      </div>
      <div class="information_bar">
        <div class="information_title">{{ $t('职位') }}</div>
        <div>{{ user.position }}</div>
      </div>
      <div class="information_bar">
        <div class="information_title">{{ $t('角色') }}</div>
        <div>{{ user.role }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Icon } from 'vant'
import { getStaffById } from '@/services/api'
Vue.use(Icon)
export default {
  name: 'userDetail',
  data() {
    return {
      userId: '',
      haveTwodepartment: false,
      user: {},
      sourceIsH5: true,
    }
  },
  components: {},
  methods: {
    showDetail() {
      console.log(this.userId, 'userId')
    },
    goBack() {
      console.log('click back')
      this.$router.back()
    },
    callPhone() {
      window.location.href = `tel://${this.user.mobile}`
    },
  },
  mounted() {
    this.userId = this.$route.query.userId
    getStaffById(this.userId).then((res) => {
      this.user = {
        name: res.name ? res.name : '',
        companyName: res.companyName ? res.companyName : '',
        mobile: res.mobile ? res.mobile : '',
        mail: res.email ? res.email : '',
        department: res.departmentName
          ? res.departmentName.replaceAll(',', '/')
          : '',
        department2: '',
        position: res.jobPost ? res.jobPost : '',
        role:
          res.roleList && res.roleList.length > 0
            ? res.roleList.map((item) => item.name).join('/')
            : '',
      }
    })
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.container {
  height: 100%;
}
.nav_row {
  display: flex;
  height: 40px;
  align-items: center;

  .arrow {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .back-title {
    margin-left: 5px;
  }
}
.header {
  width: 100%;
  display: flex;
  height: 154px;
  padding-inline: 24px;
  flex-direction: column;
  background-image: url('../../assets/images/userDetail_bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
  .userView {
    display: flex;
    margin-top: 37px;
    align-items: center;
    .name {
      color: #ffffff;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    .company {
      color: #ffffff;
      font-size: 14px;
    }
  }
  .avatar {
    width: 64px;
    height: 64px;
    margin-right: 16px;
  }
}
.body {
  display: flex;
  padding: 10px;
  flex-direction: column;
  .information_bar {
    height: 64px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 5px;
    border-bottom: 1px solid #e8e8e8;
    .information_title {
      color: #383838;
      font-size: 14px;
      font-weight: bold;
      margin-right: 24px;
      white-space: nowrap;
    }
    .mobile_view {
      width: 240px;
      display: flex;
      color: #00bfff;
      flex-direction: row;
      align-items: center;
    }
    .phone_call {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
